import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface TextDividerProps {
  content: string;
  className?: string;
}
export const TextDivider: FC<TextDividerProps> = ({ content, className = '' }) => {
  return (
    <div className={mergeClasses('flex w-full flex-row', className)}>
      <div className="flex w-full items-center justify-center gap-4">
        <div className="flex h-full w-full bg-gradient-to-l from-gray-400 to-gray-400 bg-[length:100%_1px] bg-center bg-no-repeat" />
        <div className="text-nowrap text-sm text-gray-400">{content}</div>
        <div className="flex h-full w-full bg-gradient-to-l from-gray-400 to-gray-400 bg-[length:100%_1px] bg-center bg-no-repeat" />
      </div>
    </div>
  );
};
